<template>
    <qb-panel :title="titulo.toUpperCase()" class="qb-margin-top">
      <table>
        <thead>
          <tr>
            <th>Nome</th>
            <th>Login</th>
            <th>Gestor</th>
            <th>Ativo</th>
            <th>Ação</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="usuario in usuarios" v-bind:key="usuario.id">
            <td>{{usuario.name}}</td>
            <td>{{usuario.login}}</td>
             <td v-if="usuario.manager == 'S'">Habilitado</td>
            <td v-else>Desabilitado</td>
            <td v-if="usuario.active == 'S'">Ativado</td>
            <td v-else>Desativado</td>
            <td>
              <button class="btn btn-dark" style="color:black;" @click="openEditWindow(usuario)">Editar</button>
            </td>
          </tr>
        </tbody>

      </table>
      <button @click="openEditWindow()" class="btn btn-primary">
        Adicionar Usuário
      </button>

      <modal key="edit" name="edit" :adaptive="true" height="auto" :resizable="true" :scrollable="true"  style="padding:10px;">
        <p style="font-weight: 600;font-size: 20px;margin-left:20px;">Editar Usuario</p>    
        <form class="FormAcesso" method="get">
          <label>Nome</label><br>
          <input type="text" v-model="editar_usuario.nome" required /><br><br>
          <label>Login</label><br>
          <input type="text" v-model="editar_usuario.login" required /><br><br>

          <label>E-mail</label><br>
          <input type="text" v-model="editar_usuario.email" required /><br><br>

          <label>Senha</label><br>
          <input type="text" v-model="editar_usuario.password" required /><br><br>


          <label>Ativação</label><br>
          <input type="radio" id="ativo" value="S" v-model="editar_usuario.ativo" required>
          <label for="ativo">Ativado</label>
          <br>
          <input type="radio" id="inativo" value="N" v-model="editar_usuario.ativo" required>
          <label for="inativo">Desativado</label><br><br>
          <br>

          <label>Habilitar Gestor</label><br>
          <input type="radio" id="habilitado" value="S" v-model="editar_usuario.gestor" required>
          <label for="habilitado">Habilitado</label>
          <br>
          <input type="radio" id="desabilitado" value="N" v-model="editar_usuario.gestor" required>
          <label for="desabilitado">Desativado</label>
          <br>
          <p style="color:red;">{{message}}</p>
          <button class="btn btn-primary" v-if="editar_usuario.id != ''" @click="salvar">
             Alterar
          </button>
           <button class="btn btn-primary" v-else @click="adicionar">
             Salvar
          </button>
        </form>
      </modal>

    </qb-panel>
</template>

<script>
import axios from "axios";
import { baseApiUrl } from "@/global";
import { userKey } from "@/global";

export default {
name: 'Acessos',

  components: {
  },

  data(){
      return{
        usuarios: [],
        titulo: 'Acessos',
        paginas: 0,
        paginaAtual: 0,
        listaPronta: false,
        message:'',
        editar_usuario: {
          customerID:'',
          nome : '',
          login : '',
          email : '',
          ativo : '',
          gestor :'',
          id : '',
          password: '',
        },
        vazio: false
    }
  },

   methods:{
        carregaLista(){
          const json = localStorage.getItem(userKey);
          const userData = JSON.parse(json);
          this.editar_usuario.customerID  = userData.idCliente
          this.message = '';
          this.carregaAcessos(userData.idCliente);
        },
        carregaAcessos(idCliente){
            axios.get(`${baseApiUrl}/login/acesso/?idCliente=${idCliente}`)
            .then(res => {
             this.usuarios = res.data;
            });            
        },
        openEditWindow(user){
          if(user)
          {
            this.editar_usuario.nome = user.name;
            this.editar_usuario.login = user.login;
            this.editar_usuario.email = user.email;
            this.editar_usuario.ativo = user.active;
            this.editar_usuario.gestor = user.manager;
            this.editar_usuario.password = '';
            this.editar_usuario.id = user.id;
          }
          else
          {
            this.editar_usuario.nome = '';
            this.editar_usuario.login = '';
            this.editar_usuario.email = '';
            this.editar_usuario.ativo = '';
            this.editar_usuario.gestor ='';
            this.editar_usuario.password = '';
            this.editar_usuario.id = '';
          }
          this.$modal.show('edit');
      },
      salvar(e)
      {
        e.preventDefault();
        if( this.editar_usuario.nome !='' &&
            this.editar_usuario.login  !='' &&
            this.editar_usuario.email  !='' &&
            this.editar_usuario.password  !='' 
            )
        {
          e.preventDefault();
          axios.get(`${baseApiUrl}/login/edit/?userID=${this.editar_usuario.id}&nome=${this.editar_usuario.nome}&login=${this.editar_usuario.login.toUpperCase()}&email=${this.editar_usuario.email}&ativo=${this.editar_usuario.ativo}&gestor=${this.editar_usuario.gestor}&password=${this.editar_usuario.password}`)
          .then(res => {
            if(res.data==1)
            {
              alert("Usuário alterado com sucesso.");
              this.carregaLista();
              this.$modal.hide('edit');             
            }else{
              alert(res.data);
            }
          }).catch(error => {
            alert(error.ToString());
          });
        }else{
          this.message = "Preencha todos os campos acima.";
        }
      },
      adicionar(e)
      {
        e.preventDefault();
        if( this.editar_usuario.nome !='' &&
            this.editar_usuario.login  !='' &&
            this.editar_usuario.email  !='' &&
            this.editar_usuario.password  !='')
        {
          axios.get(`${baseApiUrl}/login/insert/?nome=${this.editar_usuario.nome}&login=${this.editar_usuario.login.toUpperCase()}&email=${this.editar_usuario.email}&ativo=${this.editar_usuario.ativo}&gestor=${this.editar_usuario.gestor}&customerId=${this.editar_usuario.customerID}&password=${this.editar_usuario.password}`)
          .then(res => {
            if(res.data==1)
            {
              alert("Usuário criado com sucesso.");
              this.carregaLista();
              this.$modal.hide('edit');             
            }else{
              alert(res.data);
            }
          }).catch(error => {
            alert(error.ToString());
          });
        }else{
          e.preventDefault();
          this.message = "Preencha todos os campos acima.";
        }
      },
   },
    created(){
        this.carregaLista();        
    },
  }
</script>

<style>

  table
  {
    width: 100%;
    padding: 10px;
  }

  button:hover
  {
    cursor: pointer;
  }

  v-modal
  {
    padding: 20px;
  }

  table thead th
  {
    text-align: left;
    border-bottom: 1px solid silver;
  }

  .btn-primary
  {
    margin-left: auto;
    margin-right: 5px;
    margin-top: 50px;
    margin-bottom: 10px;
    padding: 10px;
  }

  .FormAcesso
  {
    padding: 10px;
    width: 40%;
  }

</style>
